import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

export interface IEmbedParams {
  hideHeader: boolean
  hideNav: boolean
  hideFooter: boolean
  isEmbedMode: boolean
  enabledSections: string[] | null
  enabledBlocks: string[] | null
}

const parseArrayParam = (value: string | null): string[] | null => {
  if (!value) {
    return null
  }
  return value.split(',').filter(Boolean)
}

export const useEmbedParams = (): IEmbedParams => {
  const location = useLocation()

  return useMemo(() => {
    const hashParams = new URLSearchParams(location.search)

    const windowParams = new URLSearchParams(window.location.search)

    const hideHeader =
      hashParams.get('hideHeader') === 'true' || windowParams.get('hideHeader') === 'true'

    const hideNav = hashParams.get('hideNav') === 'true' || windowParams.get('hideNav') === 'true'

    const hideFooter =
      hashParams.get('hideFooter') === 'true' || windowParams.get('hideFooter') === 'true'

    const enabledSectionsRaw =
      hashParams.get('enabledSections') || windowParams.get('enabledSections') || null
    const enabledBlocksRaw =
      hashParams.get('enabledBlocks') || windowParams.get('enabledBlocks') || null

    const enabledSections = parseArrayParam(enabledSectionsRaw)
    const enabledBlocks = parseArrayParam(enabledBlocksRaw)

    const isEmbedMode = hideHeader || hideNav || hideFooter || location.pathname.includes('/embed/')

    return {
      hideHeader,
      hideNav,
      hideFooter,
      isEmbedMode,
      enabledSections,
      enabledBlocks,
    }
  }, [location.search, location.pathname])
}

export default useEmbedParams
